import script from "./infoTipsBox.vue?vue&type=script&setup=true&lang=js"
export * from "./infoTipsBox.vue?vue&type=script&setup=true&lang=js"

import "./infoTipsBox.vue?vue&type=style&index=0&id=4aaf6776&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aaf6776"]])

export default __exports__